import React, { useState, useEffect } from "react";
import logo from "../assets/images/logo.png";
import logo2 from "../assets/images/lion-logo.png";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useUser } from "../components/context/UserContext";
import translations from "../Translation/login.json";
import { api, setAuthToken } from "../api";

const Login = () => {
  const { setUser } = useUser();

  const [form, setForm] = useState({ email: "", password: "" });
  const [hide, setHide] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("admin-mobile-token");
    if (token) window.location.replace("/dashboard");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await api.post("/api/auth/login", {
        email: form.email,
        password: form.password,
      });

      const token = res?.data?.token;

      if (!token) {
        const msg = "Log masuk gagal. Token tidak diterima.";
        setMessage(msg);
        alert(msg);
        return;
      }

      localStorage.setItem("admin-mobile-token", token);
      setAuthToken(token);

      const userData = res?.data?.user || {
        name: "Admin",
        email: form.email,
        role: "USER",
      };

      setUser({
        name: userData.name || "Admin",
        email: userData.email || form.email,
        role: userData.role || "USER",
      });

      setMessage(translations?.messages?.login_success || "Log masuk berjaya.");

      window.location.replace("/dashboard");
    } catch (error) {
      console.error("Login error:", error?.response?.data || error.message);

      const msg =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        translations?.messages?.login_failed ||
        "Log masuk gagal. Sila semak maklumat anda.";

      setMessage(msg);
      alert(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <div className="w-full h-screen flex flex-col justify-center items-center p-5 login">
      <div className="w-full max-w-3xl">
        <div className="flex flex-col items-center p-5 w-full">
          <img src={logo2} className="w-24 mb-8" alt="Logo" />
          <img src={logo} className="w-96 mb-4" alt="Logo" />
          <h3 className="text-xl font-bold text-gray-700 mb-8 uppercase">
            {translations?.headings?.title || "Log Masuk"}
          </h3>

          <form onSubmit={handleSubmit} className="w-full">
            <div className="border-2 rounded-lg mb-3 w-full">
              <input
                type="text"
                name="email"
                value={form.email}
                onChange={handleChange}
                className="py-2 px-3 w-[99%] m-1 outline-none"
                placeholder={translations?.placeholders?.email || "Email"}
                required
              />
            </div>

            <div className="flex items-center border-2 rounded-lg mb-8">
              <input
                type={hide ? "text" : "password"}
                name="password"
                value={form.password}
                onChange={handleChange}
                className="py-2 px-3 m-1 outline-none w-full"
                placeholder={translations?.placeholders?.password || "Password"}
                required
              />
              <div
                className="py-2 px-3 cursor-pointer"
                onClick={() => setHide((prev) => !prev)}
              >
                <FontAwesomeIcon icon={hide ? faEyeSlash : faEye} />
              </div>
            </div>

            {message ? (
              <div className="mb-4 text-center text-sm text-gray-700">{message}</div>
            ) : null}

            <div className="flex justify-center">
              <button
                type="submit"
                disabled={loading}
                className="py-2 px-3 w-32 rounded-lg text-white bg-indigo-500 font-semibold hover:bg-indigo-600 disabled:opacity-50"
              >
                {loading
                  ? translations?.buttons?.signing_in || "Sedang Log Masuk..."
                  : translations?.buttons?.sign_in || "Log Masuk"}
              </button>
            </div>
          </form>

          <Link to="">
            <p className="mt-4 text-sm text-gray-600 underline cursor-pointer hover:text-blue-500">
              {translations?.links?.forgot_password || "Lupa Kata Laluan?"}
            </p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;